// Real A1 Screening pool cage / screen enclosure project photos.
//
// Source: photos provided by John (Feb 2026). Originals live in
// /public/images/gallery/originals/. Optimized responsive copies live in
// /public/images/gallery/web/ and are produced by `_optimize.py` in that
// folder. Each photo has WebP + JPEG fallbacks at md (≤800px) and lg (≤1600px).
//
// Public-facing wording rules (per John, Phase 11 update):
//   - Photos may show finished work OR work in progress. Default wording is
//     neutral ("Pool Cage & Screen Enclosure Project") — never "completed",
//     "finished", "before/after", "full rescreen", "storm damage repair",
//     "same-day", "guaranteed", "licensed and insured" unless an admin
//     explicitly confirms it for that individual photo.
//   - Do not claim a specific city per photo (Naples / Fort Myers / etc.)
//     unless `confirmed_city` is filled in below.
//   - Do not claim a specific service per photo unless
//     `confirmed_service_type` is filled in.

export const COMPLETED_WORK_PHOTOS = [
    {
        id: "pcw-01",
        // Photo shows a technician working on a pool cage. Portrait orientation.
        base_path: "/images/gallery/web/pool-cage-completed-work-01",
        intrinsic: { w: 461, h: 1024 },
        // Tall photo — gets a portrait aspect ratio in the grid.
        aspect_class: "aspect-[4/5]",
        object_position: "object-top",
        alt: "A1 Screening pool cage and screen enclosure project photo",
        title: "Pool Cage & Screen Enclosure Project",
        category: "pool-cage-screen-enclosure",
        is_verified_real_job: true,
        is_before_after: false,
        confirmed_city: null,
        confirmed_service_type: null,
        original_file_type: "png",
        optimized_file_type: "webp",
        show_on_homepage: true,
        show_on_gallery: true,
        show_on_service_page: true,
    },
    {
        id: "pcw-02",
        base_path: "/images/gallery/web/pool-cage-completed-work-02",
        intrinsic: { w: 1024, h: 768 },
        aspect_class: "aspect-[4/3]",
        object_position: "object-center",
        alt: "Pool cage and screen enclosure work by A1 Screening",
        title: "Pool Cage & Screen Enclosure Project",
        category: "pool-cage-screen-enclosure",
        is_verified_real_job: true,
        is_before_after: false,
        confirmed_city: null,
        confirmed_service_type: null,
        original_file_type: "png",
        optimized_file_type: "webp",
        show_on_homepage: true,
        show_on_gallery: true,
        show_on_service_page: true,
    },
    {
        id: "pcw-03",
        base_path: "/images/gallery/web/pool-cage-completed-work-03",
        intrinsic: { w: 720, h: 535 },
        aspect_class: "aspect-[4/3]",
        object_position: "object-center",
        alt: "A1 Screening pool cage and screen enclosure project photo",
        title: "Pool Cage & Screen Enclosure Project",
        category: "pool-cage-screen-enclosure",
        is_verified_real_job: true,
        is_before_after: false,
        confirmed_city: null,
        confirmed_service_type: null,
        original_file_type: "jpg",
        optimized_file_type: "webp",
        show_on_homepage: true,
        show_on_gallery: true,
        show_on_service_page: true,
    },
    {
        id: "pcw-04",
        base_path: "/images/gallery/web/pool-cage-completed-work-04",
        intrinsic: { w: 720, h: 540 },
        aspect_class: "aspect-[4/3]",
        object_position: "object-center",
        alt: "A1 Screening job site photo",
        title: "Pool Cage & Screen Enclosure Project",
        category: "pool-cage-screen-enclosure",
        is_verified_real_job: true,
        is_before_after: false,
        confirmed_city: null,
        confirmed_service_type: null,
        original_file_type: "jpg",
        optimized_file_type: "webp",
        show_on_homepage: true,
        show_on_gallery: true,
        show_on_service_page: true,
    },
    {
        id: "pcw-05",
        base_path: "/images/gallery/web/pool-cage-completed-work-05",
        intrinsic: { w: 720, h: 523 },
        aspect_class: "aspect-[4/3]",
        object_position: "object-center",
        alt: "A1 Screening pool cage and screen enclosure project photo",
        title: "Pool Cage & Screen Enclosure Project",
        category: "pool-cage-screen-enclosure",
        is_verified_real_job: true,
        is_before_after: false,
        confirmed_city: null,
        confirmed_service_type: null,
        original_file_type: "jpg",
        optimized_file_type: "webp",
        show_on_homepage: true,
        show_on_gallery: true,
        show_on_service_page: true,
    },
];

// Service slugs that should display the completed-work gallery. Per John:
// only on the broad pool-cage / pool-rescreening pages — NOT condo or
// screen-door, since those photos are pool-cage / screen-enclosure work.
export const SERVICES_THAT_SHOW_COMPLETED_WORK = new Set([
    "pool-cage-repair",
    "pool-rescreening",
]);
